'use client'
import { storage } from '../utils/CurrencySelector/ExchangeStorage'

export async function getExchangeRates() {
  if (typeof window === 'undefined') return
  // Try to get cached rates first
  let rates = storage.getRates()

  if (!rates) {
    try {
      // Use our own backend rate (the same DailyExchangeRate the server uses to
      // compute the charge) so displayed prices match checkout exactly, and we no
      // longer depend on a flaky external FX API. The endpoint returns USD-based
      // rates (USD: 1) under message.conversion_rates.conversion_rates.
      const base = process.env.NEXT_PUBLIC_API_BASE_URL
      const response = await fetch(
        `${base}/v2/dailyexchangerate/?base_currency=USD`,
      )
      const data = await response.json()
      const usdBaseRates: Record<string, number> | undefined =
        data?.message?.conversion_rates?.conversion_rates

      if (usdBaseRates && usdBaseRates.USD) {
        storage.setRates(usdBaseRates)
        rates = usdBaseRates
      } else {
        throw new Error('Failed to fetch rates')
      }
    } catch (error) {
      console.error('Rate fetch error:', error)
      // Fallback to USD if no rates available (display only; the charge is always
      // computed server-side, so this can never cause an undercharge).
      rates = { USD: 1 }
    }
  }

  return rates
}
